import { render, staticRenderFns } from "./StarterEditionSales.vue?vue&type=template&id=74c53d5c"
import script from "./StarterEditionSales.vue?vue&type=script&lang=js"
export * from "./StarterEditionSales.vue?vue&type=script&lang=js"
import style0 from "./StarterEditionSales.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports